var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "all_form_block" }, [
      _c("form", [
        _c("div", { staticClass: "block" }, [
          _c("div", { staticClass: "name_tools" }, [_vm._v("Color")]),
          _vm._v(" "),
          _c("div", { staticClass: "all_form" }, [
            _c("div", { staticClass: "color_block" }, [
              _c("div", { staticClass: "radio_color" }, [
                _c("input", {
                  attrs: {
                    checked: "",
                    id: "color_radio_1",
                    name: "color_radio",
                    type: "radio"
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticStyle: { background: "#FBCB02" },
                  attrs: { for: "color_radio_1" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio_color" }, [
                _c("input", {
                  attrs: {
                    id: "color_radio_2",
                    name: "color_radio",
                    type: "radio"
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticStyle: { background: "#FC5833" },
                  attrs: { for: "color_radio_2" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "radio_color" }, [
                _c("input", {
                  attrs: {
                    id: "color_radio_3",
                    name: "color_radio",
                    type: "radio"
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticStyle: { background: "#2BD7D7" },
                  attrs: { for: "color_radio_3" }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed5f33bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed5f33bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/color.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ed5f33bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/color.vue
// module chunks = 0